// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__EcFOd","rootSmall":"AddTileButton_rootSmall__3lbXO"};